import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useRef } from 'react';
import cx from 'classnames';
import useMount from 'react-use/lib/useMount';
import { TimelineMax } from 'gsap/TweenMax';
import Button from './Button';
import Icon from './Icon';
import { config } from '../helpers/config';

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      className = _ref.className,
      panelClassName = _ref.panelClassName,
      _onComplete = _ref.onComplete,
      _onReverseComplete = _ref.onReverseComplete,
      onReverseStart = _ref.onReverseStart,
      _onStart = _ref.onStart,
      position = _ref.position,
      trigger = _ref.trigger,
      showArrow = _ref.showArrow,
      opts = _objectWithoutPropertiesLoose(_ref, ["children", "className", "panelClassName", "onComplete", "onReverseComplete", "onReverseStart", "onStart", "position", "trigger", "showArrow"]);

  var dropdownRef = useRef();
  var dropdownPanelRef = useRef();
  var dropdownTriggerRef = useRef();

  var dropdownOpen = function dropdownOpen() {
    var $dropdown = dropdownRef.current;
    if ($dropdown && $dropdown.timeline) $dropdown.timeline.play();
  };

  var dropdownClose = function dropdownClose() {
    var $dropdown = dropdownRef.current;
    if ($dropdown && $dropdown.timeline) $dropdown.timeline.reverse();
  };
  /**
   * Determine if click originates from outside `.dropdown-panel`
   * @param  {event} e
   * @return {false}
   */


  var checkInside = function checkInside(e) {
    if (e.target.closest('.dropdown-panel') === null) {
      dropdownClose();
      return;
    }

    return false;
  };

  var attachTimeline = function attachTimeline() {
    var $dropdown = dropdownRef.current;
    var $trigger = dropdownTriggerRef.current;
    var $panel = dropdownPanelRef.current;
    var forward = true;
    var lastTime = 0; // Attach GSAP

    $dropdown.timeline = new TimelineMax({
      paused: true,
      onStart: function onStart() {
        _onStart();

        $dropdown.classList.add(config.classes.open); // Toggle aria state

        $dropdown.setAttribute('aria-expanded', true); // Add active class from trigger

        $trigger.classList.add(config.classes.active);
      },
      onComplete: function onComplete() {
        _onComplete();

        document.addEventListener('click', checkInside, false);
      },
      onUpdate: function onUpdate() {
        var newTime = $dropdown.timeline.time();

        if (forward && newTime < lastTime || !forward && newTime > lastTime) {
          forward = !forward;

          if (!forward) {
            onReverseStart();
            $dropdown.classList.remove(config.classes.open); // Toggle aria state

            $dropdown.setAttribute('aria-expanded', false); // Remove active class from trigger

            $trigger.classList.remove(config.classes.active);
          }
        }

        lastTime = newTime;
      },
      onReverseComplete: function onReverseComplete() {
        _onReverseComplete();

        document.removeEventListener('click', checkInside, false);
      }
    });
    $dropdown.timeline.set($panel, {
      display: 'block'
    }).to($panel, 0.175, {
      css: {
        y: 0,
        scale: 1,
        opacity: 1
      },
      ease: config.easingBounce
    });
  };

  useMount(function () {
    attachTimeline();
  });

  var handleDropdownToggle = function handleDropdownToggle() {
    var $dropdown = dropdownRef.current;

    if ($dropdown.timeline.progress() === 1) {
      dropdownClose();
    } else {
      dropdownOpen();
    }
  };

  var classes = cx('dropdown', {
    'dropdown--center': position === 'center',
    'dropdown--right': position === 'right',
    'dropdown--up': position === 'up-left',
    'dropdown--up dropdown--center': position === 'up-center',
    'dropdown--up dropdown--right': position === 'up-right'
  }, className);
  var panelClasses = cx('dropdown-panel', panelClassName);
  return React.createElement("div", Object.assign({
    className: classes,
    "aria-haspopup": "true",
    "aria-expanded": "false",
    ref: dropdownRef
  }, opts), React.createElement(Button, Object.assign({
    onClick: handleDropdownToggle
  }, trigger.props, {
    ref: dropdownTriggerRef
  }), trigger.label, showArrow && React.createElement(Icon, {
    size: "small",
    icon: "caret-down",
    className: "dropdown-arrow"
  })), React.createElement("div", {
    className: panelClasses,
    ref: dropdownPanelRef
  }, children));
};

Dropdown.defaultProps = {
  onComplete: function onComplete() {},
  onReverseComplete: function onReverseComplete() {},
  onReverseStart: function onReverseStart() {},
  onStart: function onStart() {},
  position: 'left'
};
export default Dropdown;